import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { WinLossResponseData } from "../response/data/WinLossResponseData";
/**
 * WinLossRequest.ts
 */
export class WinLossRequest extends WebRequest {
    constructor() {
        super(WinLossRequest.URL);
    }
    getMethod() {
        return RequestConstants.GET;
    }
    getDataClass() {
        return WinLossResponseData;
    }
}
WinLossRequest.URL = "/gamecloud-servlets/api/user/realityCheckWinLoss";
//# sourceMappingURL=WinLossRequest.js.map